import { cn } from '@/lib/utils'

/** A storefront as its two-letter code (US, KR, JP) in a small pill. Flag
 *  emoji are drawn differently on every platform and as letters on Windows,
 *  so the code is the label. */
export function CountryTag({ code, className }: { code: string; className?: string }) {
  const c = (code || '').trim().toUpperCase()
  if (!c) return null
  return (
    <span
      className={cn(
        'inline-flex h-5 shrink-0 items-center rounded border border-border px-1.5 font-mono text-micro font-medium text-muted-foreground',
        className,
      )}
    >
      {c}
    </span>
  )
}
